import { Entity } from "excalibur";
import { ResourcePerTurnComponent } from "./ecs/resources";
import { StrictEventEmitter } from "./engine/types";
import { MyLevel } from "./level";
import { CardId, CardPack, DynamicResources, ResourceKind } from "./types";

export class HudEvent {
  constructor() {}
}

export class HudCardSwapEvent {
  constructor(public context: { a: CardId; b: CardId }) {}
}

export class HudCardMoveEvent {
  constructor(public context: { cardId: CardId; newIndex: number }) {}
}

export class HudBuyPackEvent {
  constructor(public context: { packName: string }) {}
}

export class HudShopClickedEvent {
  constructor() {}
}

export class HudShopCloseEvent {
  constructor() {}
}

export class HudRestartGameEvent {
  constructor() {}
}

export class HudHelpClickedEvent {
  constructor() {}
}

export class HudHelpCloseEvent {
  constructor() {}
}

export type HudEvents = {
  //endClicked: HudEvent;

  drawclicked: HudEvent;
  swapcardsinhand: HudCardSwapEvent;
  movecardinhand: HudCardMoveEvent;
  undoclicked: HudEvent;
  buypack: HudBuyPackEvent;
  shopclicked: HudShopClickedEvent;
  shopclose: HudShopCloseEvent;
  restartgame: HudRestartGameEvent;
  helpclicked: HudHelpClickedEvent;
  helpclose: HudHelpCloseEvent;
};

export const HudEvents = {
  //resetClicked: "resetclicked",

  swapCardsInHand: "swapcardsinhand",
  moveCardInHand: "movecardinhand",
  drawClicked: "drawclicked",
  undoClicked: "undoclicked",
  buyPack: "buypack",
  shopClicked: "shopclicked",
  shopClose: "shopclose",
  restartGame: "restartgame",
  helpClicked: "helpclicked",
  helpClose: "helpclose",
} as const;

interface HasHudInterface {
  hudInterface: HudInterface;
}

export function hasHudInterface(o: unknown): o is HasHudInterface {
  return !!(o as HasHudInterface).hudInterface;
}

export class HudInterface {
  // public API for hud to interact with game
  public events = new StrictEventEmitter<HudEvents>();

  // UI state
  public showShop: boolean = false;
  public isShopOpenDueToOutOfCards: boolean = false;
  public showGameOver: boolean = false;
  public showHelp: boolean = false;

  // resetPlayerTurn() {
  //   this.events.emit(HudEvents.resetClicked, new HudEvent());
  // }

  // endPlayerTurn() {
  //   this.events.emit(HudEvents.endClicked, new HudEvent());
  // }

  get rows() {
    return this.level.tileManager.rows;
  }

  get cols() {
    return this.level.tileManager.cols;
  }

  constructor(private level: MyLevel) {}

  buyPack(pack: CardPack): boolean {
    this.events.emit("buypack", new HudBuyPackEvent({ packName: pack.name }));
    return true;
  }

  getMoney(): number {
    return this.level.gameState.money;
  }

  getTurnCount(): number {
    return this.level.gameState.turnCount;
  }

  getUnlockedResources(): Set<ResourceKind> {
    return this.level.gameState.seenResources;
  }

  canUndo() {
    return this.level.snapshotState != undefined;
  }

  undoLastAction() {
    console.log("undo clicked!");
    this.events.emit(HudEvents.undoClicked, new HudEvent());
  }

  lastUndoDescription(): string | undefined {
    return undefined;
  }

  swapCardsInHand(a: CardId, b: CardId) {
    this.events.emit(HudEvents.swapCardsInHand, new HudCardSwapEvent({ a, b }));
  }

  moveCardInHand(cardId: CardId, newIndex: number) {
    this.events.emit(HudEvents.moveCardInHand, new HudCardMoveEvent({ cardId, newIndex }));
  }

  drawCard() {
    this.events.emit(HudEvents.drawClicked, new HudEvent());
  }

  getMaxHandSize(): number {
    return this.level.cards.maxHandSize;
  }

  canDrawCard(): boolean {
    return this.level.cards.canDraw();
  }

  shopClicked() {
    this.events.emit(HudEvents.shopClicked, new HudShopClickedEvent());
  }

  closeShop() {
    this.events.emit(HudEvents.shopClose, new HudShopCloseEvent());
  }

  restartGame() {
    this.events.emit(HudEvents.restartGame, new HudRestartGameEvent());
  }

  helpClicked() {
    this.events.emit(HudEvents.helpClicked, new HudHelpClickedEvent());
  }

  closeHelp() {
    this.events.emit(HudEvents.helpClose, new HudHelpCloseEvent());
  }

  getResourcesAtTile(
    x: number,
    y: number,
  ): {
    name: string;
    label: string;
    total: DynamicResources;
  } | null {
    const tileComponents = this.level.tileManager.at(x, y);
    if (!tileComponents || tileComponents.length === 0) return null;

    const entities: Entity<ResourcePerTurnComponent>[] = [];
    if (tileComponents.length > 1) {
      console.warn("Too many entities on tile!", tileComponents);
    }

    const entity = tileComponents[0].owner;
    if (!entity) return null;

    const resourceComponent = entity.get(ResourcePerTurnComponent);
    if (!resourceComponent) return null;

    entities.push(entity as Entity<ResourcePerTurnComponent>);

    // Check if this is a building with unlock information

    const total = resourceComponent.resources;
    return { total, name: entity.name, label: resourceComponent.label };
  }
}
